<script setup lang="ts">
import { computed } from 'vue'
import type { Emits, Props } from './type'

defineOptions({
  name: 'AppPageMask',
})

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const dialogLabel = computed(() => (props.kind === 'wechat' ? '微信打开提示' : '下载二维码'))
</script>

<template>
  <div
    v-if="open"
    class="app-page-mask"
    :class="`is-${kind}`"
    role="dialog"
    aria-modal="true"
    :aria-label="dialogLabel"
    @click.self="emit('close')"
  >
    <img
      v-if="kind === 'wechat'"
      class="app-page-mask__wechat-guide"
      :src="guideImage"
      alt="点击右上角，在浏览器中打开"
    />

    <div v-else class="app-page-mask__qr-panel">
      <h3 class="app-page-mask__qr-title">请扫码下载造梦次元App</h3>
      <img class="app-page-mask__qr-image" :src="qrImage" alt="造梦次元App下载二维码" />
    </div>
  </div>
</template>

<style scoped>
.app-page-mask {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgb(0 0 0 / 0.68);
}

.app-page-mask.is-wechat {
  padding: 18px 14px 14px;
}

.app-page-mask.is-qr {
  display: grid;
  padding: 24px;
}

.app-page-mask__wechat-guide {
  display: block;
  width: 160px;
  height: auto;
  margin-right: 0;
  margin-left: auto;
}

.app-page-mask__qr-panel {
  width: min(320px, 90vw);
  align-self: center;
  justify-self: center;
  padding: 16px 16px 14px;
  color: #171717;
  text-align: center;
  background: #fff;
  border-radius: 14px;
}

.app-page-mask__qr-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
}

.app-page-mask__qr-image {
  display: block;
  width: 100%;
  max-width: 260px;
  height: auto;
  margin: 14px auto 0;
  border-radius: 8px;
}
</style>
